import anyAscii from "any-ascii";

export const anyAsciiCode = (code: string): string => {
  return anyAscii(code);
};
